export const BRAND = {
  name: "OESCA",
  suffix: "CONSTRUCCIONES",
  location: "Zapopan, Jalisco, México",
  phone: "33 1088 7228",
  email: "contacto@oescaconstrucciones.com",
  web: "oescaconstrucciones.com",
  address:
    "Calle Abogados No. 638, Jardines de Guadalupe C.P. 45030, Zapopan, Jalisco, México.",
};

export const HERO = {
  eyebrow: "Zapopan · Jalisco · México",
  intro:
    "Somos una constructora integral que transforma planos en infraestructuras tangibles, especializándonos en soluciones que equilibran la ingeniería de alta resistencia con una gestión de proyectos transparente.",
};

export const MARQUEE_ITEMS = [
  "Construcción",
  "Infraestructuras",
  "Obra pesada",
  "Materiales pesados",
  "Oesca",
  "Ingeniería civil",
  "Ingeniería de proyectos",
];

export const QUIENES_SOMOS = {
  title: "¿Quiénes somos?",
  text: "Nos definimos por la solidez técnica y el rigor administrativo en la ejecución de obras de construcción complejas. Somos una constructora integral que transforma planos en infraestructuras tangibles, especializándonos en soluciones que equilibran la ingeniería de alta resistencia con una gestión de proyectos transparente. En Oesca nos identifican nuestra capacidad para coordinar trabajos especializados en diversos sectores nos posiciona como el brazo ejecutor de confianza para quienes buscan durabilidad y cumplimiento normativo en cada etapa del proceso de construcción.",
  mision:
    "Nuestra misión general es ejecutar proyectos de construcción y servicios de ingeniería con los más altos estándares de calidad y seguridad, optimizando recursos mediante una administración de obra inteligente y transparente.",
  vision:
    "Ser el referente nacional en construcción especializada e industrial, distinguiéndonos por nuestra capacidad técnica para resolver desafíos estructurales complejos y por la integridad de nuestros procesos operativos.",
};

export const DISTINTIVOS = [
  {
    title: "Gestión Administrativa Blindada",
    text: "Implementamos un control riguroso de presupuestos y suministros, eliminando variaciones de costos imprevistas y asegurando una transparencia total para el inversionista.",
  },
  {
    title: "Especialización en Obra Pesada",
    text: "Poseemos la capacidad técnica y el equipo para ejecutar cimentaciones y estructuras industriales complejas que requieren un nivel de ingeniería superior al promedio.",
  },
  {
    title: "Supervisión con Criterio de Ingeniería",
    text: "Nuestra dirección de obra no es solo administrativa; evaluamos cada etapa con un enfoque técnico preventivo para evitar vicios ocultos y garantizar la vida útil de la estructura.",
  },
  {
    title: "Ejecución de Trabajos Especializados In-House",
    text: "Reducimos la dependencia de subcontratistas en procesos críticos, lo que nos permite mantener un estándar de calidad uniforme y un cumplimiento estricto del cronograma.",
  },
  {
    title: "Garantía de Cumplimiento Normativo",
    text: "Nos aseguramos de que cada m³ construido cumpla estrictamente con los reglamentos de construcción y seguridad industrial, brindando certeza jurídica a cada proyecto.",
  },
];

export const SERVICIOS = [
  {
    title: "Diseño e Ingeniería Estructural",
    text: "Desarrollo de proyectos ejecutivos y cálculos avanzados para asegurar la viabilidad técnica y seguridad de cualquier tipo de edificación.",
  },
  {
    title: "Construcción Industrial y de Naves",
    text: "Ejecución de plantas y centros logísticos con especificaciones técnicas rigurosas, garantizando espacios funcionales para procesos productivos pesados.",
  },
  {
    title: "Obras de Urbanización e Infraestructura",
    text: "Desarrollo de vialidades, redes hidrosanitarias y proyectos de servicios básicos para nuevos fraccionamientos y zonas comerciales.",
  },
  {
    title: "Construcción Habitacional y Comercial",
    text: "Edificación de inmuebles residenciales y locales comerciales, enfocándonos en la calidad de los procesos constructivos y la optimización de espacios.",
  },
  {
    title: "Administración y Supervisión de Obra",
    text: "Gerencia técnica que asegura el cumplimiento de tiempos, presupuestos y normativas de seguridad, actuando como garantes de la inversión del cliente",
  },
];

export const SEGMENTOS = [
  {
    title: "Desarrolladores Inmobiliarios",
    text: "Clientes que requieren una empresa con capacidad de urbanizar y construir complejos habitacionales de manera simultánea y eficiente.",
  },
  {
    title: "Sector Industrial y Logístico",
    text: "Compañías que necesitan naves industriales o plantas de producción ejecutadas bajo estrictas normas de ingeniería civil y seguridad.",
  },
  {
    title: "Inversionistas Patrimoniales",
    text: "Dueños de capital que buscan edificar locales comerciales u oficinas con una administración de obra que garantice el retorno de su inversión.",
  },
  {
    title: "Instituciones Públicas y Privadas",
    text: "Entidades que demandan servicios de ingeniería y supervisión para obras de infraestructura urbana o edificios de servicios generales.",
  },
];

export const TESTIMONIOS = [
  {
    quote:
      "Colaborar con Oesca es garantía de que los planos se respetarán al pie de la letra; su disciplina en la supervisión de obra es de las más rigurosas del sector aquí en el estado.",
    author: "Ing. Carlos Méndez",
    role: "Consultor Estructural",
  },
  {
    quote:
      "Nuestra planta de producción fue un desafío logístico, pero Oesca demostró una capacidad técnica excepcional para manejar cimentaciones profundas y estructuras pesadas.",
    author: "Grupo Industrial del Centro",
    role: "Cliente Industrial",
  },
  {
    quote:
      "Lo que más valoro de Oesca es la transparencia administrativa; su gerencia de proyecto me permitió tener claridad total sobre el uso de cada peso invertido.",
    author: "Lic. Adriana Ruíz",
    role: "Inversionista",
  },
  {
    quote:
      "Como aliados estratégicos, Oesca nos ha brindado servicios de ingeniería y arquitectura que son fundamentales para el éxito de nuestras licitaciones más complejas.",
    author: "Constructora Global S.A.",
    role: "Aliado Estratégico",
  },
];

export const NAV_LINKS = [
  { label: "Inicio", hash: "#inicio" },
  { label: "Quiénes Somos", hash: "#quienes-somos" },
  { label: "Distintivos", hash: "#distintivos" },
  { label: "Servicios", hash: "#servicios" },
  { label: "Proyectos", hash: "#proyectos" },
  { label: "Testimonios", hash: "#testimonios" },
];
